module.exports = __webpack_public_path__ + "static/media/corona-bottle.99fa855b.png";